let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("178fH")).then(() => parcelRequire('oX1H3'));